module.exports = __webpack_public_path__ + "media/images/country_flags/pt-3f85d389239a166e28b463e234347f0e.png";